function SubscribedCheck({ dimensions, col = '#fff' }) {
    const baseXml = `
    <svg width="${dimensions || '24'}" height="${dimensions || '24'}" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="${col}" stroke-width="2"/>
      <path d="M7 12.5L10.5 16L17 9" stroke="${col}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

    return baseXml;
}

export default SubscribedCheck;
